import createLucideIcon from '../createLucideIcon';

const Upload = createLucideIcon('UploadIcon', [
  ['path', { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', key: 'ih7n3h' }],
  ['polyline', { points: '17 8 12 3 7 8', key: 't8dd8p' }],
  ['line', { x1: '12', y1: '3', x2: '12', y2: '15', key: 'wktxj0' }],
]);

export default Upload;
